import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { MetaNavItem, NavMenuType, PrimaryNavItem, UserAccountData } from '@hdms/shared/page-frame/types';

import { AccountLinksService } from '../../../services';

@Component({
  selector: 'shrd-pf-ft-burger-menu-secondary-content',
  templateUrl: './burger-menu-secondary-content.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BurgerMenuSecondaryContentComponent {
  @Input() menuItem: PrimaryNavItem | MetaNavItem;
  @Input() userData: UserAccountData;

  @Output() accountChanged = new EventEmitter<string>();

  readonly menuTypes = NavMenuType;

  readonly userProfileLinks$ = this.accountLinksService.userProfileLinks$;
  readonly favoritesLinks$ = this.accountLinksService.favoritesLinks$;
  readonly documentsLinks$ = this.accountLinksService.documentsLinks$;
  readonly tpmLinks$ = this.accountLinksService.tpmLinks$;

  constructor(private readonly accountLinksService: AccountLinksService) {}
}
